module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/ChangePassword/changepassword.component.css
// module id = ./src/app/Screens/ChangePassword/changepassword.component.css
// module chunks = main